import type { QueryKeyData, QueryParams } from '@pba/react-query';
import { type CommunityDetail, createCommunityDetail } from '#models';
import { useQuery } from '#query';
import { type CommunityDetailQueryFilter, getCommunityDetailQueryKey } from '#query-keys/communities';
import { getCommunity } from '../services';

export type CommunityDetailQueryData = QueryKeyData<CommunityDetail, typeof getCommunityDetailQueryKey>;

export type GetCommunityDetailParams = {
  id: string;
} & QueryParams<CommunityDetailQueryData, CommunityDetailQueryFilter>;

export const useCommunityQuery = ({ filter, id, options }: GetCommunityDetailParams) =>
  useQuery({
    async queryFn() {
      const { data } = await getCommunity({
        config: {
          params: {
            invitation_token: filter.invitationToken,
          },
        },
        routeParams: { id },
      });

      return createCommunityDetail(data);
    },
    queryKey: getCommunityDetailQueryKey({ filter, id }),
    refetchOnMount: filter.invitationToken ? 'always' : undefined,
    ...options,
  });
